<template>
	<div>
		<div class="main" style="margin-top: 0px;">
			<div class="part_title">
				{{region1_name}}
			</div>
			<div class="part_summary">
				{{region1_summary}}
			</div>
			<div class="part_link" @click="toUrl(region1_url)" style="cursor: pointer;">
				点击进入{{region1_name}}>>
			</div>
		</div>
		
		<div class="wenda_part">
			<div class="main">
				<el-row :gutter="20">
					<el-col :span="6" style="background-color: #006ccd;" v-for="(item, index) in list_wenda" :key="index">
						<div class="wenda_part_region" @click="toUrl(item.url)" style="padding: 0px;">
							<div class="wenda_part_region_icon">
								<el-image :src="$common.adimgUrl + item.icon" style="width: 305px; height: 280px;"></el-image>
							</div>
						</div>
					</el-col>
				</el-row>
			</div>
		</div>
		
		<!-- <div class="wenda_part">
			<div class="main">
				<el-row :gutter="20">
					<el-col :span="6" style="background-color: #006ccd;" v-for="(item, index) in list_wenda" :key="index">
						<div class="wenda_part_region" @click="toUrl(item.url)">
							<div class="wenda_part_region_icon">
								<el-image :src="$common.adimgUrl + item.icon" style="height: 70px;" fit="contain"></el-image>
							</div>
							<div class="wenda_part_region_title">
								{{item.title}}
							</div>
							<div class="wenda_part_region_summary">
								{{item.summary}}
							</div>
						</div>
					</el-col>
				</el-row>
			</div>
		</div> -->
		
		<div class="main" style="margin-top: 0px;">
			<div class="part_title">
				{{region2_name}}
			</div>
			<div class="part_summary">
				{{region2_summary}}
			</div>
			<div class="part_link" @click="toUrl(region2_url)" style="cursor: pointer;">
				点击进入{{region2_name}}>>
			</div>
		</div>
		<div class="main" style="margin-top: 20px;">
			<el-row :gutter="20">
				<el-col :span="8" v-for="(item, index) in list_shuju" :key="index">
					<div class="shuju_box" @click="toUrl(item.url)" style="padding: 0px;">
						<div class="shuju_box_icon" style="width: auto; height: auto; margin: 0px; padding: 0px;">
							<el-image :src="$common.adimgUrl + item.icon" style="width: 415px; height: 296px;"></el-image>
						</div>
					</div>
				</el-col>
			</el-row>
		</div>
		<!-- <div class="main" style="margin-top: 20px;">
			<el-row :gutter="20">
				<el-col :span="8" v-for="(item, index) in list_shuju" :key="index">
					<div class="shuju_box" @click="toUrl(item.url)">
						<div class="shuju_box_icon">
							<el-image :src="$common.adimgUrl + item.icon" style="height: 70px;" fit="contain"></el-image>
						</div>
						<div class="shuju_box_title">
							{{item.title}}
						</div>
						<div class="shuju_box_summary">
							{{item.summary}}
						</div>
						<div class="shuju_box_slogan">
							{{item.keyword}}
						</div>
					</div>
				</el-col>
			</el-row>
		</div> -->
		
	</div>
</template>

<script>
	export default {
		props: ['region1_name', 'region1_summary', 'region1_url', 'region2_name', 'region2_summary', 'region2_url'],
		data() {
			return {
				list_wenda: [],
				list_shuju: []
			}
		},
		
		created() {
			
		},
		
		mounted() {
			this.loadWenda()
			this.loadShuju()
		},
		
		methods: {
			// 加载问询与答复4个推荐
			loadWenda () {
				this.$axios.get(this.$common.apiUrl + 'pub_web_config/detail/10009').then((res) => {
					this.list_wenda = eval('(' + res.data.data.configJson + ')')
				})
			},
			
			// 加载数据分析3个推荐
			loadShuju() {
				this.$axios.get(this.$common.apiUrl + 'pub_web_config/detail/10010').then((res) => {
					this.list_shuju = eval('(' + res.data.data.configJson + ')')
				})
			},
			
			// web配置数据链接跳转
			toUrl(url) {
				// console.log(url)
				if (url.indexOf('http') > -1) {
					location.href = url
				} else {
					this.$router.push({path: url})
				}
			},
			
			
			
		}
	}
</script>

<style>
</style>